import Dexie from 'dexie';
import { liveQuery } from 'dexie';

import { getAddress } from 'viem';

export const db = new Dexie('LTCcs');
db.version(1).stores({
  txs: '&[chain+hash], [chain+address+hash+txType], chain, address, contractAddress, from, functionName, hash, isError, methodId, timeStamp, to, transactionIndex, value, contractType, [chain+address+txType], [chain+address+blockNumber+txType], [chain+address+contractType], [address+contractType], [chain+contractAddress], [chain+to], [chain+from], [chain+contractType]',
  logs: '[chain+address+transactionHash+transactionIndex+logIndex], chain, address, transactionHash, transactionIndex, *args, eventName, logIndex, [chain+address], [transactionHash+transactionIndex], [chain+address+eventName], [chain+address+args.role.value]',
  ipfsFolders: 'Hash, Name',
  ipfsFile: '[cId+content]'
});

export const addressTxs = (chain, address) => {
  address = getAddress(address)
  return liveQuery(
    () => db.txs
      .where('[chain+to]').equals([ chain, address ])
      .or('[chain+from]').equals([ chain, address ])
      .or('[chain+contractAddress]').equals([ chain, address ])
      .reverse().sortBy('timeStamp')
  );
}

export const txLogs = async hash => await db.logs.where({ transactionHash: hash }).toArray();

export const addressContracts = (chain, address, contractType, filterFn) => {
  address = getAddress(address);
  const where = { chain, address };
  if (contractType) where.contractType = contractType;
  return liveQuery( () => {
    let data = db.txs.where(where);
    if (filterFn) {
      data = data.filter(filterFn);
    }
    return data.reverse().sortBy('timeStamp')
  } );
}

export const collectionTokensEvents = (chain, address, tokenId, eventName) => {
  address = getAddress(address);
  return liveQuery( () => db.logs.where({ chain, address, eventName }) );
}

export const contractEvents = (chain, address, eventName) => {
  eventName = Array.isArray(eventName) ? eventName : [ eventName ];
  address = getAddress(address);
  return liveQuery(
    () => db.logs.where({ chain, address }).and(log => eventName.includes(log.eventName)).toArray()
  );
}
